import React from "react";
import { css } from "react-emotion";
import * as styles from "../newStyles.styles";
import Footer from "../Footer";
import Header from "../Header";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";

const body = css`
  * {
    *,
    *:before,
    *:after {
      box-sizing: inherit;
    }
  }
  height: 100%;
  margin: 0;
  padding-top: 0.1px;
`;
// classes
const wrapper = css`
  width: 100%;
  margin: 0 auto;
  float: none;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  min-height: 100vh;
`;

function SupportSmallBiz({ history }) {
  return (
    <div className={body}>
      <div className={wrapper}>
        <Header history={history} />
        <main
          style={{
            width: "100%",
            minHeight: "100vh",
            backgroundColor: "rgb(255, 255, 255)",
            flex: "1 0 auto",
            textAlign: "center",
          }}
        >
          <div className={styles.row}>
            <div className={styles.maxWidthWrapper}>
              <div
                className={styles.col + " " + styles.col1}
                style={{ textAlign: "-webkit-center" }}
              >
                <styles.H2
                  style={{
                    marginBottom: "60px",
                    marginTop: "60px",
                    textAlign: "left",
                  }}
                >
                  Help someone dream{" "}
                  <span
                    className={styles.styledUnderline}
                    style={{ fontSize: "45px" }}
                  >
                    BIG
                  </span>
                  , by supporting small.
                </styles.H2>
                <img
                  src="https://mobile360-assets.s3.us-east-2.amazonaws.com/support_small_business.jpeg"
                  className={styles.fullPic}
                />
                <styles.P style={{ lineHeight: "1.875", textAlign: "left" }}>
                  By supporting small businesses, you’re directly supporting
                  your local community. These small businesses help create and
                  sustain jobs, making sure your community is as vibrant,
                  authentic, and original as ever. When you support a small
                  business, you’re supporting real people in pursuing their
                  passions.
                  <br />
                  <br />
                  Although small businesses form the bedrock of our economy,
                  they face unique challenges, including upfront costs, lack of
                  brand awareness, and less technological know-how. Black and
                  Brown owned small businesses are especially under-represented
                  and under-funded.
                  <br />
                  <br />
                  Mobile360 aims to level the playing field for small businesses
                  by providing them with the resources, technological
                  capabilities, and human capital to build their business in the
                  digital age. We are especially committed to supporting the
                  development and growth of minority-owned small businesses and
                  entrepreneurs from underserved communities.
                  <br />
                  <br />
                  Every time you support a Mobile360 small business, you are
                  taking part in a piece of our Business Owner’s dreams.
                </styles.P>
              </div>
            </div>
          </div>
          <styles.P
            style={{
              marginBottom: "30px",
              fontWeight: "bold",
              fontSize: "20px",
            }}
          >
            Download the Marketplace App
          </styles.P>
          <div style={{ marginTop: "2em", marginBottom: "1em" }}>
            <div className={styles.bouncingArrow}>
              <ArrowDownwardIcon fontSize="large" />
            </div>
          </div>
          <div className={styles.flexyRowCol} style={{ marginBottom: "30px" }}>
            <a
              href="https://apps.apple.com/us/app/mobile360/id1466921046"
              target="_blank"
            >
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/apple-store.svg"
                // style={{ height: "75px" }}
                alt="Download on the app store logo png"
                className={styles.appleStore}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.mobile360.android"
              target="_blank"
            >
              <img
                src="https://mobile360-assets.s3.us-east-2.amazonaws.com/google-play-store.svg"
                // width="257"
                // height="112"
                alt="google play itunes png logo"
                className={styles.googlePlayStore}
              />
            </a>
          </div>
        </main>
        <Footer />
      </div>
    </div>
  );
}

export default SupportSmallBiz;
